import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhCampaignAnalytics extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhCampaignAnalytics'
  // Define default properties here
  static instanceDefaults() {
    return {
      campaign_id: null,
      total_ratings: 0,
      tokens_distributed: 0,
      average_rating: 0,
      completion_rate: 0,
      campaign_name: '',
      is_cached: false,
      cached_at: null
    }
  }
}
const servicePath = 'bh-campaign-analytics';
const servicePlugin = makeServicePlugin({
  Model: BhCampaignAnalytics,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
